/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/custom-carousel.js":
/*!******************************************!*\
  !*** ./js/components/custom-carousel.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules */ "./node_modules/swiper/modules/index.mjs");


var _excluded = ["breakpoints"],
  _excluded2 = ["pagination", "navigation", "linked", "scrollBar"],
  _excluded3 = ["navigation", "pagination", "progressPagination", "scrollBar", "linked"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


class CustomCarousel extends HTMLElement {
  constructor() {
    super();
    this.carouselSettings;
    this.currentWidth;
    this.innerHTML;
    this.container;
  }
  connectedCallback() {
    if (this.innerHTML.length > 0) {
      this.initCarousel();
    } else {
      var that = this;
      var checkHtmlLength = window.setInterval(() => {
        if (this.innerHTML.length > 0) {
          that.initCarousel();
          window.clearInterval(checkHtmlLength);
          checkHtmlLength = false;
        }
      }, 500);
      window.setTimeout(() => {
        if (checkHtmlLength) {
          window.clearInterval(checkHtmlLength);
        }
      }, 5000);
    }
  }
  getCarouselSettings() {
    this.currentWidth = window.innerWidth;
    //default settings
    var defaultSettings = {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 1000,
      navigation: false
    };
    var carouselSettings = defaultSettings;
    //end of default settings 

    //handle breakpoint
    var _this$carouselSetting = this.carouselSettings,
      {
        breakpoints
      } = _this$carouselSetting,
      otherSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$carouselSetting, _excluded);
    if (breakpoints) {
      this.breakpoints = Object.keys(breakpoints);
      this.breakpoints.forEach((breakpoint, index) => {
        if (this.currentWidth >= breakpoint) {
          if (breakpoints[breakpoint]) {
            this.breakpointSettings = breakpoints[breakpoint];
          } else {
            this.breakpointSettings = breakpoints[this.breakpoints[index - 1]];
          }
          var _this$breakpointSetti = this.breakpointSettings,
            {
              pagination,
              navigation,
              linked,
              scrollBar
            } = _this$breakpointSetti,
            otherResponsiveSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$breakpointSetti, _excluded2);
          this.carouselSettings = _objectSpread(_objectSpread(_objectSpread({}, otherSettings), otherResponsiveSettings), {}, {
            pagination,
            navigation,
            linked
          });
        }
      });
    }
    if (this.carouselSettings && Object.keys(this.carouselSettings).length > 0) {
      var _this$carouselSetting2 = this.carouselSettings,
        {
          navigation,
          pagination,
          progressPagination,
          scrollBar,
          linked
        } = _this$carouselSetting2,
        otherSwiperSettings = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_this$carouselSetting2, _excluded3);
      carouselSettings = _objectSpread({}, otherSwiperSettings);
      if (navigation) {
        var navigationNext = this.querySelector('.swiper-navigation--next');
        var navigationPrev = this.querySelector('.swiper-navigation--prev');
        carouselSettings = _objectSpread(_objectSpread({}, carouselSettings), {}, {
          navigation: {
            nextEl: navigationNext,
            prevEl: navigationPrev
          }
        });
      }
      if (pagination) {
        var swiperPagination = this.querySelector('.swiper-pagination');
        var _pagination = {
          el: swiperPagination,
          clickable: true
        };
        if (progressPagination) {
          _pagination = {
            el: swiperPagination,
            type: 'progressbar'
          };
        }
        carouselSettings = _objectSpread(_objectSpread({}, carouselSettings), {}, {
          pagination: _pagination
        });
      }
      if (linked) {
        var linkedSlider = window.carousels["".concat(this.carouselSettings.linked)];
        //get thumbs
        if (linkedSlider) {
          carouselSettings.thumbs = {
            swiper: linkedSlider
          };
        }
      }
      if (scrollBar) {
        var _scrollBar = this.querySelector('.swiper-scrollbar');
        carouselSettings.scrollbar = {
          el: _scrollBar,
          draggable: true,
          // Snaps slider position to slides when you release Scrollbar
          snapOnRelease: true,
          // Size (Length) of Scrollbar Draggable Element in px
          dragSize: 'auto'
        };
      }
    }
    return carouselSettings;
  }
  initCarousel() {
    var _this$querySelector, _this$querySelector2, _this$querySelector3;
    this.carouselSettings = JSON.parse(((_this$querySelector = this.querySelector('[data-settings]')) === null || _this$querySelector === void 0 ? void 0 : _this$querySelector.innerHTML) || "{}");
    this.carouselContent = (_this$querySelector2 = this.querySelector('[data-carousel-content]')) === null || _this$querySelector2 === void 0 ? void 0 : _this$querySelector2.innerHTML;
    this.placeholders = (_this$querySelector3 = this.querySelector('[data-carousel-placeholder]')) === null || _this$querySelector3 === void 0 ? void 0 : _this$querySelector3.innerHTML;
    this.navigations = this.querySelector('[data-swiper-navigations]');
    this.currentWidth = window.innerWidth;
    window.carousels = window.carousels || {};
    var swiperNavigationElements = "\n      <div class=\"swiper-navigation swiper-navigation--next ".concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n      <svg width=\"8\" height=\"15\" viewBox=\"0 0 8 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.71429 7.5L2.48389e-07 1.25L1.14286 3.54204e-07L6.85714 6.25L8 7.5L1.14286 15L-8.44396e-07 13.75L5.71429 7.5Z\" fill=\"#231F20\"/>\n      </svg>      \n    </div>\n    <div class=\"swiper-navigation swiper-navigation--prev ").concat(this.carouselSettings.overflowNagivation ? "swiper-navigation--overflow" : '', "\">\n    <svg width=\"8\" height=\"15\" viewBox=\"0 0 8 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.28571 7.5L8 1.25L6.85714 3.54204e-07L1.14286 6.25L-6.55671e-07 7.5L6.85714 15L8 13.75L2.28571 7.5Z\" fill=\"#231F20\"/>\n    </svg>    \n    </div>\n    ");
    this.carouselContent ? this.innerHTML = "<div class=\"carousel__container swiper hide\" data-swiper-container>\n    <div class=\"swiper-wrapper\">\n    ".concat(this.carouselContent, "\n    </div> </div>\n    <div class=\"swiper-pagination\"></div>\n    ").concat(this.carouselSettings['customNavigation'] ? '' : swiperNavigationElements, "\n    ").concat(this.placeholders ? this.placeholders : "<div class=\"carousel-placeholders\"></div>") : this.carouselSettings['customNavigation'] ? '' : this.navigations.innerHTML = swiperNavigationElements;
    this.container = this.querySelector('[data-swiper-container]');
    var carouselSettings = this.getCarouselSettings();
    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](this.container, _objectSpread({
      on: {
        beforeInit: () => {
          var {
            navigation,
            pagination
          } = carouselSettings || {};
          if (!navigation) {
            this.querySelectorAll('.swiper-navigation').forEach(navigation => navigation.classList.add('swiper-navigation--hide'));
          } else {
            this.querySelector('.swiper-navigation--hide') && this.querySelectorAll('.swiper-navigation--hide').forEach(navigation => navigation.classList.remove("swiper-pagination--hide"));
          }
          if (!pagination) {
            this.querySelectorAll('.swiper-pagination').forEach(navigation => navigation.classList.add('swiper-pagination--hide'));
          } else {
            this.querySelector('.swiper-pagination--hide') && this.querySelectorAll('.swiper-pagination--hide').forEach(navigation => navigation.classList.remove("swiper-pagination--hide"));
          }
        },
        init: swiper => {
          if (!!swiper.navigation) {
            swiper.navigation.destroy();
          }
        },
        afterInit: () => {
          var _this$querySelector4;
          this.querySelector('.carousel__container').classList.remove('hide');
          (_this$querySelector4 = this.querySelector('.carousel-placeholders')) === null || _this$querySelector4 === void 0 || _this$querySelector4.classList.add('hide');
        },
        init: swiper => {
          var name = this.carouselSettings.name;
          if (name) {
            window.carousels = window.carousels || {};
            window.carousels["".concat(name)] = swiper;
          }
        }
      },
      modules: [swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Navigation, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Pagination, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Thumbs, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Scrollbar]
    }, carouselSettings));
    this.swiper.on('activeIndexChange', current => {
      var _this$querySelector5, _this$querySelectorAl;
      (_this$querySelector5 = this.querySelector('.swiper-pagination-bullet-active')) === null || _this$querySelector5 === void 0 || _this$querySelector5.classList.remove('swiper-pagination-bullet-active');
      (_this$querySelectorAl = this.querySelectorAll('.swiper-pagination-bullet')[current.activeIndex]) === null || _this$querySelectorAl === void 0 || _this$querySelectorAl.classList.add('swiper-pagination-bullet-active');
    });
  }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomCarousel);

/***/ }),

/***/ "./js/components/registerCustomElements.js":
/*!*************************************************!*\
  !*** ./js/components/registerCustomElements.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_custom_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/custom-carousel */ "./js/components/custom-carousel.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  customElements.define('custom-carousel', JsComponents_custom_carousel__WEBPACK_IMPORTED_MODULE_0__["default"]);
});

/***/ }),

/***/ "./js/components/zoom.js":
/*!*******************************!*\
  !*** ./js/components/zoom.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var handleZoom = function handleZoom(ev, image) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  console.log(offset, "offset");
  var xPosition = ev.clientX - 200 - offset;
  var yPosition = ev.clientY - 150;
  var style = "\n      transform: scale(3);\n      transform-origin: ".concat(xPosition, "px ").concat(yPosition, "px \n    ");
  image.style = style;
};
var toggleZoom = (image, add) => {
  var isZoomActive = document.querySelector('.zoom--active');
  if (isZoomActive) {
    isZoomActive.classList.remove('zoom--active');
    isZoomActive.removeEventListener('mousemove', ev => {
      handleZoom(ev, image);
    });
  }
  if (add) {
    var zoomContainer = image.querySelector('[data-zoom-container]');
    zoomContainer.classList.add('zoom--active');
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  var zoomEls = document.querySelectorAll('[data-zoom-parent]');
  zoomEls.forEach(zoomEl => {
    var images = zoomEl.querySelectorAll('[data-zoom]');
    images.forEach(image => {
      image.addEventListener('click', () => {
        if (document.querySelector('.zoom--active')) {
          toggleZoom(image, false);
        } else {
          toggleZoom(image, true);
        }
      });
      image.addEventListener('mouseleave', () => {
        toggleZoom(image, false);
      });
    });
  });

  //add trigger for the zoom container
  var zoomContainers = document.querySelectorAll('[data-zoom-container]');
  zoomContainers.forEach(container => {
    container.addEventListener('mousemove', ev => {
      var _container$dataset;
      ev.preventDefault();
      var zoomOffset = 0;
      if (container !== null && container !== void 0 && (_container$dataset = container.dataset) !== null && _container$dataset !== void 0 && _container$dataset.zoomOffset) {
        zoomOffset = container.dataset.zoomOffset;
      }
      var image = container.querySelector('img');
      if (image) {
        handleZoom(ev, image, zoomOffset);
      }
    });
  });
});

/***/ }),

/***/ "./js/sections/landing-gold-fbb.js":
/*!*****************************************!*\
  !*** ./js/sections/landing-gold-fbb.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/svelte-wrapper */ "./js/components/svelte-wrapper.js");
/* harmony import */ var JsComponents_landing_page_buy_box_buy_box_svelte__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/landing-page-buy-box/buy-box.svelte */ "./js/components/landing-page-buy-box/buy-box.svelte");
/* harmony import */ var JsComponents_landing_page_buy_box_star_reviews_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/landing-page-buy-box/star-reviews.svelte */ "./js/components/landing-page-buy-box/star-reviews.svelte");
/* harmony import */ var JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/scroll-on-click */ "./js/components/scroll-on-click.js");




var handleStickyCta = () => {
  var options = {
    threshold: 0.5
  };
  var observer = new IntersectionObserver((entries, observer) => {
    var stickyBuyBoxGroup = document.querySelectorAll('.floating-purchase-options');
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        stickyBuyBoxGroup.forEach(stickyBuyBox => {
          if (stickyBuyBox.classList.contains('show-purchase-options')) {
            stickyBuyBox.classList.remove('show-purchase-options');
          }
        });
      } else {
        stickyBuyBoxGroup.forEach(stickyBuyBox => {
          stickyBuyBox.classList.add('show-purchase-options');
          requestAnimationFrame(() => {
            var floatingPurchaseOptions = stickyBuyBox;
            var clientHeight = floatingPurchaseOptions.clientHeight;
            document.documentElement.style.setProperty('--floating-purchase-options-height', "".concat(clientHeight, "px"));
          });
        });
      }
    });
  }, options);
  var getScrollPosition = ev => {
    var currentPosition = window.scrollY;
    return currentPosition;
  };
  var customBuyBox = [...document.querySelectorAll('[data-buybox-custom]')];
  window.addEventListener('scroll', ev => {
    var currentPosition = getScrollPosition(ev);
    if (currentPosition > 700) {
      customBuyBox.forEach(buybox => {
        observer.observe(buybox);
      });
      window.removeEventListener('scroll', handleScroll);
    }
  });
  var handleScroll = ev => {
    var currentPosition = getScrollPosition(ev);
    if (currentPosition > 700) {
      customBuyBox.forEach(buybox => {
        observer.observe(buybox);
      });
      window.removeEventListener('scroll', handleScroll);
    }
  };
  window.addEventListener('scroll', handleScroll);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  (0,JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(JsComponents_landing_page_buy_box_buy_box_svelte__WEBPACK_IMPORTED_MODULE_1__["default"], 'custom-buy-box', '#product-data');
  (0,JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(JsComponents_landing_page_buy_box_star_reviews_svelte__WEBPACK_IMPORTED_MODULE_2__["default"], 'star-reviews', '#product-data');
  (0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.product-buy-button', '.landing-page-buy-box.landing-page-buy-box--alternate', 100);
  (0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.product-buy-button-mian', '.landing-page-buy-box--alternate', 100);
  var buyNowBtns = document.querySelectorAll('[data-buy-now-button]');
  buyNowBtns.forEach(buyNowBtn => {
    buyNowBtn.addEventListener('click', () => {
      var _window$custom;
      (_window$custom = window.custom) === null || _window$custom === void 0 || _window$custom.handleBuyBox();
    });
  });
  handleStickyCta();
});

/***/ }),

/***/ "./js/sections/landing-page-sticky-buybox.js":
/*!***************************************************!*\
  !*** ./js/sections/landing-page-sticky-buybox.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/svelte-wrapper */ "./js/components/svelte-wrapper.js");
/* harmony import */ var JsComponents_landing_page_buy_box_sticky_buy_box_svelte__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/landing-page-buy-box/sticky-buy-box.svelte */ "./js/components/landing-page-buy-box/sticky-buy-box.svelte");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  (0,JsComponents_svelte_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(JsComponents_landing_page_buy_box_sticky_buy_box_svelte__WEBPACK_IMPORTED_MODULE_1__["default"], 'sticky-buy-box', '#product-data');
});

/***/ }),

/***/ "./js/sections/new-header-nav.js":
/*!***************************************!*\
  !*** ./js/sections/new-header-nav.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export newHeader */
var newHeader = () => {
  var tabs = document.querySelectorAll('[data-mobile-tab]');
  var panels = document.querySelectorAll('[data-mobile-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var shouldRedirect = this.getAttribute('data-redirect') === 'true';
      var tabUrl = this.getAttribute('data-mobile-tab-url');

      // If tab should redirect (About, Articles, etc.), navigate to URL
      if (shouldRedirect && tabUrl) {
        window.location.href = tabUrl;
        return;
      }

      // Otherwise, switch tab content (Shop tab)
      var tabIndex = this.getAttribute('data-mobile-tab');

      // Update active tab
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // Show corresponding panel
      panels.forEach(function (panel) {
        if (panel.getAttribute('data-mobile-panel') === tabIndex) {
          panel.style.display = 'block';
          panel.classList.add('is-active');
        } else {
          panel.style.display = 'none';
          panel.classList.remove('is-active');
        }
      });
    });
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (newHeader);

/***/ }),

/***/ "./js/sections/rebuy-button-changes.js":
/*!*********************************************!*\
  !*** ./js/sections/rebuy-button-changes.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var rebuyButtonChanges = () => {
  // Function to modify the button when found
  var modifyButton = button => {
    // Prevent multiple modifications
    if (button.dataset.modified === 'true') {
      return;
    }

    // Change button text
    button.textContent = 'CONTINUE SHOPPING';
    button.style.margin = '0 auto';

    // Add click redirect
    button.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/collections/shop-all';
    });

    // Mark as modified
    button.dataset.modified = 'true';
  };

  // Try to find button immediately
  var initialButton = document.querySelector('.rebuy-notification-dialog-button');
  if (initialButton) {
    modifyButton(initialButton);
  }

  // Use MutationObserver to watch for dynamically created buttons
  var observer = new MutationObserver(mutations => {
    var button = document.querySelector('.rebuy-notification-dialog-button');
    if (button && button.dataset.modified !== 'true') {
      modifyButton(button);
    }
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also check periodically as a fallback (in case MutationObserver misses it)
  var checkInterval = setInterval(() => {
    var button = document.querySelector('.rebuy-notification-dialog-button');
    if (button && button.dataset.modified !== 'true') {
      modifyButton(button);
    }
  }, 1000);

  // Stop checking after 30 seconds to avoid infinite polling
  setTimeout(() => {
    clearInterval(checkInterval);
  }, 30000);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (rebuyButtonChanges);

/***/ }),

/***/ "./js/sections/sections.js":
/*!*********************************!*\
  !*** ./js/sections/sections.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _landing_gold_fbb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./landing-gold-fbb */ "./js/sections/landing-gold-fbb.js");
/* harmony import */ var _landing_page_sticky_buybox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./landing-page-sticky-buybox */ "./js/sections/landing-page-sticky-buybox.js");
/* harmony import */ var JsComponents_registerCustomElements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/registerCustomElements */ "./js/components/registerCustomElements.js");
/* harmony import */ var _components_zoom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/zoom */ "./js/components/zoom.js");
/* harmony import */ var _rebuy_button_changes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./rebuy-button-changes */ "./js/sections/rebuy-button-changes.js");
/* harmony import */ var _new_header_nav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./new-header-nav */ "./js/sections/new-header-nav.js");






document.addEventListener('DOMContentLoaded', () => {
  (0,_landing_gold_fbb__WEBPACK_IMPORTED_MODULE_0__["default"])();
  (0,_landing_page_sticky_buybox__WEBPACK_IMPORTED_MODULE_1__["default"])();
  (0,JsComponents_registerCustomElements__WEBPACK_IMPORTED_MODULE_2__["default"])();
  (0,_components_zoom__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,_rebuy_button_changes__WEBPACK_IMPORTED_MODULE_4__["default"])();
  (0,_new_header_nav__WEBPACK_IMPORTED_MODULE_5__["default"])();
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"sections": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/sections.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;